<div *ngIf="dir=='fr'">
  <ng-container *ngIf="doctor.appointmentTiming==0">

    <div class="consultation-settings">
      <!-- <select [(ngModel)]="patientAppointment.location" (ngModelChange)="onAvailabilityLocationChange()" name="location" class="form-control">
                <option [value]="0" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">En
                    Cabinet</option>
                <option [value]="1" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">A
                    Distance</option>
            </select> -->
      <!-- <div class="form-group" style="text-align: center;">
        <label for="gender" style="color: black;">En Cabinet </label>
        <input
          type="radio"
          name="gender"
          [(ngModel)]="patientAppointment.location"
          (ngModelChange)="onAvailabilityLocationChange()"
          *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2"
          [value]="0"
          style="margin: 8px;"
        />
        <label for="gender" style="color: black;">A Distance</label>
        <input
          type="radio"
          name="gender"
          [(ngModel)]="patientAppointment.location"
          (ngModelChange)="onAvailabilityLocationChange()"
          [value]="1"
          *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2"
          style="margin: 8px;"
        />
      </div> -->
      <div class=" row ">
            <label for="" class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-4">Lieu:</label>

   <div class="radio-choice col-lg-8 mt-3 mt-sm-0 mt-md-3">
  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="0" />
    <span class="checkmark"></span>
    <span class="fw-bold">En Cabinet</span>
  </label>

  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="1" />
    <span class="checkmark"></span>
    <span class="fw-bold">A Distance</span>
  </label>
</div>
      </div>
     <div class="row">
            <Label class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-3" >Motif de consultation:</Label>

     <div class="col-lg-8">

<div class="position-relative w-100">
  <select class="form-control custom-select-style"
          [(ngModel)]="patientAppointment.motif">

    <option value="Consultation Régulière">
      Consultation Régulière
    </option>

    <option value="Consultation Contrôle">
      Consultation Contrôle
    </option>

    <option *ngFor="let motif of consultationMotifs"
            [value]="motif.text">
      {{ motif.text }}
    </option>

  </select>

  <i class="feather-chevrons-down select-chevron-icon"></i>
</div>


</div>

     </div>
    </div>
    <!-- <div class="w-100 p-1 bg-light rounded-4 text-center fw-bold border mb-2" style="border-radius: 0.5rem;">
      {{acutelDay}}
    </div> -->
    <!-- <h4 class="appointment-form-title">Veuillez choisir la date et l'heure du rendez-vous:</h4> -->
    <div class="card">
      <app-doctor-availabilities-calender [doctor]="doctor" [location]="patientAppointment.location"
        [disponibility]="patientAppointment.doctorAvailability" [privacy]="false" [disabled]="true"
        (disponibilityChange)="onAvailabilityChange($event)"
        [availabilitiesRequest]="availabilitiesRequest"></app-doctor-availabilities-calender>
      <span *ngIf="validating && !(patientAppointment.startDateTime.getTime()>currentDate.getTime())"
        class="invalid-feedback">Merci de spécifier l'heure de rendez-vous</span>
    </div>
  </ng-container>
  <ng-container *ngIf="doctor.appointmentTiming==1">
    <div class="consultation-settings">
      <!-- <select [(ngModel)]="patientAppointment.location" name="location" class="form-control">
                <option [value]="0" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">En
                    Cabinet</option>
                <option [value]="1" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">A
                    Distance</option>
            </select> -->
<div class=" row ">
            <label for="" class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-4">Lieu:</label>

   <div class="radio-choice col-lg-8">
  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="0" />
    <span class="checkmark"></span>
    <span class="fw-bold">En Cabinet</span>
  </label>

  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="1" />
    <span class="checkmark"></span>
    <span class="fw-bold">A Distance</span>
  </label>
</div>
      </div>
     <div class="row">
            <Label class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-3" >Motif de consultation:</Label>

     <div class="col-lg-8">

<div class="position-relative w-100">
  <select class="form-control custom-select-style"
          [(ngModel)]="patientAppointment.motif">

    <option value="Consultation Régulière">
      Consultation Régulière
    </option>

    <option value="Consultation Contrôle">
      Consultation Contrôle
    </option>

    <option *ngFor="let motif of consultationMotifs"
            [value]="motif.text">
      {{ motif.text }}
    </option>

  </select>

  <i class="feather-chevrons-down select-chevron-icon"></i>
</div>


</div>

     </div>
    </div>
    <h4 class="appointment-form-title">Veuillez choisir la date du rendez-vous:</h4>
    <div class="card">
      <app-doctor-days-calander [mode]="'DATE'" [doctor]="doctor" [dir]="dir"
        (dayChange)="patientAppointment.date = $event"></app-doctor-days-calander>
    </div>
  </ng-container>
  <ng-container *ngIf="doctor.appointmentTiming==2">
    <div class="consultation-settings">
      <!-- <select [(ngModel)]="patientAppointment.location" name="location" class="form-control">
                <option [value]="0" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">En
                    Cabinet</option>
                <option [value]="1" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">A
                    Distance</option>
            </select> -->
<div class=" row ">
            <label for="" class="col-lg-4 mt-3 mt-sm-0 mt-md-4 fw-bold">Lieu:</label>

   <div class="radio-choice col-lg-8">
  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="0" />
    <span class="checkmark"></span>
    <span class="fw-bold">En Cabinet</span>
  </label>

  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="1" />
    <span class="checkmark"></span>
    <span class="fw-bold">A Distance</span>
  </label>
</div>
      </div>
     <div class="row">
            <Label class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-3" >Motif de consultation:</Label>

     <div class="col-lg-8">

<div class="position-relative w-100">
  <select class="form-control custom-select-style"
          [(ngModel)]="patientAppointment.motif">

    <option value="Consultation Régulière">
      Consultation Régulière
    </option>

    <option value="Consultation Contrôle">
      Consultation Contrôle
    </option>

    <option *ngFor="let motif of consultationMotifs"
            [value]="motif.text">
      {{ motif.text }}
    </option>

  </select>

  <i class="feather-chevrons-down select-chevron-icon"></i>
</div>


</div>

     </div>
    </div>
    <h4 class="appointment-form-title">Veuillez choisir la date du rendez-vous:</h4>
    <div class="card">
      <app-doctor-days-calander [mode]="'DATE_TIME_SLOT'" [doctor]="doctor" (dayTimeSlotsChange)="dayTimeSlots = $event"
        (dayTimeSlotsChange)="patientAppointment.startTime  = (dayTimeSlots || [])[0]?.startTime || 0"
        [day]="calenderDate" (dayChange)="onCalanderDaySelected($event)"></app-doctor-days-calander>
    </div>
    <h4 *ngIf="calenderDate" class="appointment-form-title">Veuillez choisir l'heure du rendez-vous:</h4>
    <app-time-input [(time)]="patientAppointment.startTime" (timeChange)="validateTime()"></app-time-input>
    <span *ngIf="validating && !validateTime()" style="color: red;">Date heur n 'existe pas dans le plage horaire de ce
      jour </span>
  </ng-container>
</div>

<div *ngIf="dir=='ar'" dir="rtl">
  <ng-container *ngIf="doctor.appointmentTiming==0">
    <h4 class="appointment-form-title">اختر نوع الاستشارة الخاصة بك:</h4>
    <div class="consultation-settings">
      <!-- <select [(ngModel)]="patientAppointment.location" name="location" class="form-control">
                <option [value]="0" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">En
                    Cabinet</option>
                <option [value]="1" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">A
                    Distance</option>
            </select> -->
<div class=" row " dir="rtl">
            <label for="" class="col-lg-4 mt-3 mt-sm-0 mt-md-4 fw-bold">مكان:</label>

   <div class="radio-choice col-lg-8">
  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="0" />
    <span class="checkmark"></span>
    <span class="fw-bold">في المكتب</span>
  </label>

  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="1" />
    <span class="checkmark"></span>
    <span class="fw-bold">عن بعد</span>
  </label>
</div>
      </div>
     <div class="row">
            <Label class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-3" >سبب الاستشارة:</Label>

     <div class="col-lg-8">

<div class="position-relative w-100">
  <select class="form-control custom-select-style">
    <option value="">استشارة منتظمة</option>
    <option value="">استشارة مراقبة</option>

    
  </select>
  <i class="feather-chevrons-down select-chevron-icon"></i>
</div>

</div>

     </div>
    </div>
   
    <h4 class="appointment-form-title">الرجاء اختيار تاريخ ووقت الموعد:</h4>
    <div class="card">
      <!-- [disponibility]="patientAppointment.doctorDisponibility" -->
      <app-doctor-availabilities-calender [doctor]="doctor" [dir]="dir" [location]="patientAppointment.location"
        [disponibility]="patientAppointment.doctorAvailability" [privacy]="false" [disabled]="true"
        (disponibilityChange)="onAvailabilityChange($event)"
        [availabilitiesRequest]="availabilitiesRequest"></app-doctor-availabilities-calender>
      <span *ngIf="validating && !(patientAppointment.startDateTime.getTime()>currentDate.getTime())"
        class="invalid-feedback">يرجى تحديد وقت الموعد</span>
    </div>
  </ng-container>
  <ng-container *ngIf="doctor.appointmentTiming==1">
    <h4 class="appointment-form-title">اختر نوع الاستشارة الخاصة بك:</h4>
   <div class="consultation-settings">
      <!-- <select [(ngModel)]="patientAppointment.location" name="location" class="form-control">
                <option [value]="0" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">En
                    Cabinet</option>
                <option [value]="1" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">A
                    Distance</option>
            </select> -->
<div class=" row " dir="rtl">
            <label for="" class="col-lg-4 mt-3 mt-sm-0 mt-md-4 fw-bold">مكان:</label>

   <div class="radio-choice col-lg-8">
  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="0" />
    <span class="checkmark"></span>
    <span class="fw-bold">في المكتب</span>
  </label>

  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="1" />
    <span class="checkmark"></span>
    <span class="fw-bold">عن بعد</span>
  </label>
</div>
      </div>
     <div class="row">
            <Label class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-3" >سبب الاستشارة:</Label>

     <div class="col-lg-8">

<div class="position-relative w-100">
  <select class="form-control custom-select-style">
    <option value="">استشارة منتظمة</option>
    <option value="">استشارة مراقبة</option>

    
  </select>
  <i class="feather-chevrons-down select-chevron-icon"></i>
</div>

</div>

     </div>
    </div>
    <h4 class="appointment-form-title">الرجاء اختيار تاريخ الموعد</h4>
    <div class="card">
      <app-doctor-days-calander [mode]="'DATE'" [doctor]="doctor" [dir]="dir"
        (dayChange)="patientAppointment.date = $event"></app-doctor-days-calander>
    </div>
  </ng-container>
  <ng-container *ngIf="doctor.appointmentTiming==2">
    <h4 class="appointment-form-title">اختر نوع الاستشارة الخاصة بك:</h4>
    <div class="consultation-settings">
      <!-- <select [(ngModel)]="patientAppointment.location" name="location" class="form-control">
                <option [value]="0" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">En
                    Cabinet</option>
                <option [value]="1" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">A
                    Distance</option>
            </select> -->
<div class=" row " dir="rtl">
            <label for="" class="col-lg-4 mt-3 mt-sm-0 mt-md-4 fw-bold">مكان:</label>

   <div class="radio-choice col-lg-8">
  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==0 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="0" />
    <span class="checkmark"></span>
    <span class="fw-bold">في المكتب</span>
  </label>

  <label class="radio-card" *ngIf="doctor.timeSlotLocalSetting==1 || doctor.timeSlotLocalSetting==2">
    <input type="radio" name="location" [(ngModel)]="patientAppointment.location" [value]="1" />
    <span class="checkmark"></span>
    <span class="fw-bold">عن بعد</span>
  </label>
</div>
      </div>
     <div class="row">
            <Label class="col-lg-4 fw-bold mt-3 mt-sm-0 mt-md-3" >سبب الاستشارة:</Label>

     <div class="col-lg-8">

<div class="position-relative w-100">
  <select class="form-control custom-select-style">
    <option value="">استشارة منتظمة</option>
    <option value="">استشارة مراقبة</option>

    
  </select>
  <i class="feather-chevrons-down select-chevron-icon"></i>
</div>

</div>

     </div>
    </div>
    <h4 class="appointment-form-title">الرجاء اختيار تاريخ الموعد:</h4>
    <div class="card">
      <app-doctor-days-calander [mode]="'DATE_TIME_SLOT'" [doctor]="doctor" (dayTimeSlotsChange)="dayTimeSlots = $event"
        [dir]="dir" (dayTimeSlotsChange)="patientAppointment.startTime  = (dayTimeSlots || [])[0]?.startTime || 0"
        [day]="calenderDate" (dayChange)="onCalanderDaySelected($event)"></app-doctor-days-calander>
    </div>
    <h4 *ngIf="calenderDate" class="appointment-form-title">الرجاء اختيار وقت الموعد:</h4>
    <app-time-input [(time)]="patientAppointment.startTime" (timeChange)="validateTime()"></app-time-input>
    <span *ngIf="validating && !validateTime()" style="color: red;">التاريخ والوقت غير موجود في النطاق الزمني لهذا اليوم
    </span>
  </ng-container>
</div>
